import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.notifications.resolve;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NOTIFICATIONS_RESOLVE',
	url: '/notifications/resolve.json',
});

export { actions, reducer, sagas, selectors };
